import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consolidated-payment-report',
  templateUrl: './consolidated-payment-report.component.html',
  styleUrls: ['./consolidated-payment-report.component.scss']
})
export class ConsolidatedPaymentReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
